import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faFilter } from "@fortawesome/free-solid-svg-icons";

export default function CategoryTabs({
  onFilterChange,
  categories,
  defaultCategory,
  showFilterIcon = true,
  transition = true,
}) {
  const [activeCategory, setActiveCategory] = useState(defaultCategory);
  const [highlightPosition, setHighlightPosition] = useState(0);
  const [highlightWidth, setHighlightWidth] = useState(0);
  const tabRefs = useRef([]);

  useEffect(() => {
    const activeTab = tabRefs.current.find(
      (tab) => tab?.dataset.value === activeCategory
    );
    if (activeTab) {
      setHighlightPosition(activeTab.offsetLeft);
      setHighlightWidth(activeTab.offsetWidth);
    }
  }, [activeCategory, tabRefs]);

  const handleCategoryClick = (category) => {
    setActiveCategory(category.value);
    onFilterChange(category.value);
  };

  return (
    <div className="flex gap-4 items-center py-2 px-3 text-base font-medium text-center rounded-[45px] text-darkMode-text shadow-md relative overflow-x-auto justify-start">
      {" "}
      {/* Added justify-start back for tab alignment */}
      {showFilterIcon && (
        <FontAwesomeIcon icon={faFilter} className="text-darkMode-layer3" />
      )}
      <div
        className={`absolute py-[20px] rounded-[25px] bg-darkMode-darkGreen z-0 ${
          transition ? "transition-all duration-300 ease-in-out" : ""
        }`}
        style={{
          left: highlightPosition,
          width: highlightWidth,
        }}
      ></div>
      {categories.map((category, index) => (
        <button
          key={index}
          role="tab"
          tabIndex={0}
          data-value={category.value}
          aria-selected={activeCategory === category.value}
          onClick={() => handleCategoryClick(category)}
          ref={(el) => (tabRefs.current[index] = el)}
          className={`px-4 py-2 rounded-3xl min-w-[80px] text-nowrap 
            ${transition ? "transition-all duration-300 ease-in-out" : ""}
            relative z-10 ${
              activeCategory === category.value
                ? "text-darkMode-text shadow-lg"
                : "bg-darkMode-layer2 hover:bg-darkMode-layer3"
            }`}
        >
          {category.label}
          {/* {activeCategory === category.value && (
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="ml-2 text-darkMode-green"
            />
          )} */}
        </button>
      ))}
    </div>
  );
}
